/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BasicShopStatistics } from './BasicShopStatistics';
import {
    BasicShopStatisticsFromJSON,
    BasicShopStatisticsFromJSONTyped,
    BasicShopStatisticsToJSON,
    BasicShopStatisticsToJSONTyped,
} from './BasicShopStatistics';
import type { StatisticsBySource } from './StatisticsBySource';
import {
    StatisticsBySourceFromJSON,
    StatisticsBySourceFromJSONTyped,
    StatisticsBySourceToJSON,
    StatisticsBySourceToJSONTyped,
} from './StatisticsBySource';
import type { TurnoverByDomain } from './TurnoverByDomain';
import {
    TurnoverByDomainFromJSON,
    TurnoverByDomainFromJSONTyped,
    TurnoverByDomainToJSON,
    TurnoverByDomainToJSONTyped,
} from './TurnoverByDomain';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface LegacyMarketingAndSalesCompositionData
 */
export interface LegacyMarketingAndSalesCompositionData {
    /**
     * 
     * @type {BasicShopStatistics}
     * @memberof LegacyMarketingAndSalesCompositionData
     */
    basic?: BasicShopStatistics;
    /**
     * 
     * @type {TurnoverByDomain}
     * @memberof LegacyMarketingAndSalesCompositionData
     */
    turnoverByDomain?: TurnoverByDomain;
    /**
     * 
     * @type {StatisticsBySource}
     * @memberof LegacyMarketingAndSalesCompositionData
     */
    statisticsBySource?: StatisticsBySource;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof LegacyMarketingAndSalesCompositionData
     */
    currentSnapshot?: PrecalculationSnapshotReadMetadata;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof LegacyMarketingAndSalesCompositionData
     */
    previousSnapshot?: PrecalculationSnapshotReadMetadata;
}

/**
 * Check if a given object implements the LegacyMarketingAndSalesCompositionData interface.
 */
export function instanceOfLegacyMarketingAndSalesCompositionData(value: object): value is LegacyMarketingAndSalesCompositionData {
    return true;
}

export function LegacyMarketingAndSalesCompositionDataFromJSON(json: any): LegacyMarketingAndSalesCompositionData {
    return LegacyMarketingAndSalesCompositionDataFromJSONTyped(json, false);
}

export function LegacyMarketingAndSalesCompositionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyMarketingAndSalesCompositionData {
    if (json == null) {
        return json;
    }
    return {
        
        'basic': json['basic'] == null ? undefined : BasicShopStatisticsFromJSON(json['basic']),
        'turnoverByDomain': json['turnoverByDomain'] == null ? undefined : TurnoverByDomainFromJSON(json['turnoverByDomain']),
        'statisticsBySource': json['statisticsBySource'] == null ? undefined : StatisticsBySourceFromJSON(json['statisticsBySource']),
        'currentSnapshot': json['currentSnapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['currentSnapshot']),
        'previousSnapshot': json['previousSnapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['previousSnapshot']),
    };
}

export function LegacyMarketingAndSalesCompositionDataToJSON(json: any): LegacyMarketingAndSalesCompositionData {
    return LegacyMarketingAndSalesCompositionDataToJSONTyped(json, false);
}

export function LegacyMarketingAndSalesCompositionDataToJSONTyped(value?: LegacyMarketingAndSalesCompositionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'basic': BasicShopStatisticsToJSON(value['basic']),
        'turnoverByDomain': TurnoverByDomainToJSON(value['turnoverByDomain']),
        'statisticsBySource': StatisticsBySourceToJSON(value['statisticsBySource']),
        'currentSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['currentSnapshot']),
        'previousSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['previousSnapshot']),
    };
}

